import { createFileRoute } from '@tanstack/react-router';
import { call } from '@hlt/web-kit/api';
import { prefetch } from '@/app/prefetch';
import { publicIdParam, resolveResource } from '@/app/route-ids';
import { FindingPage } from '@/features/findings/finding-page';

export const Route = createFileRoute('/_app/w/$workspaceId/findings/$findingId')({
    params: publicIdParam('findingId'),
    staticData: {
        crumbs: [{ label: 'shell.findings', to: '/w/$workspaceId/findings' }, { label: 'shell.crumbFinding' }],
    },
    beforeLoad: async ({ context, params, location }) =>
        await resolveResource({
            ref: params.findingId,
            collection: 'findings',
            location,
            read: async () =>
                await call('getFinding', { params: { ...context.workspaceScope, findingId: params.findingId } }),
        }),
    loader: ({ context, params }) => prefetch.finding(context.queryClient, context.workspaceScope, params.findingId),
    component: function FindingRoute() {
        const { organizationId, workspaceId } = Route.useRouteContext().workspaceScope;
        const { findingId } = Route.useParams();
        return <FindingPage organizationId={organizationId} workspaceId={workspaceId} findingId={findingId} />;
    },
});
